import { Box, Stack, Switch } from '@mui/material';
import { TransportFuelPipeSensorIcon } from 'app/icons';
import React from 'react';
import { paperProgressStatusStyle } from '../TabPanelConditionStyle';
const DRAIN_SENSOR_THRESHOLD = 700;
export const SensorStatusIndicators = ({ hasDrainSensor, hasFuelSensor, drainSensorValue, fuelSensorValue, isDefaultDrain, isDefaultFuel, hasDevice, }) => {
    if (!hasDrainSensor && !hasFuelSensor) {
        return null;
    }
    return (React.createElement(Stack, { direction: 'column', className: 'MuiPaperProgress-status', sx: paperProgressStatusStyle },
        hasDrainSensor && (React.createElement(Box, null,
            React.createElement(DrainSensorSwitch, { value: drainSensorValue, isDefault: isDefaultDrain, hasDevice: hasDevice }))),
        hasFuelSensor && (React.createElement(Box, null,
            React.createElement(FuelSensorIcon, { value: fuelSensorValue, hasDevice: hasDevice })))));
};
const DrainSensorSwitch = ({ value, isDefault, hasDevice }) => {
    if (!hasDevice || isDefault) {
        return React.createElement(Switch, { disabled: true, size: 'small', onChange: () => { }, checked: false });
    }
    const isChecked = Number(value) >= DRAIN_SENSOR_THRESHOLD;
    return React.createElement(Switch, { size: 'small', onChange: () => { }, checked: isChecked });
};
const FuelSensorIcon = ({ value, hasDevice }) => {
    if (!hasDevice || value === -1) {
        return React.createElement(TransportFuelPipeSensorIcon, { viewBox: '0 0 16 24', color: 'disabled' });
    }
    const color = Number(value) > 0 ? 'fuelIn' : 'fuelOut';
    return React.createElement(TransportFuelPipeSensorIcon, { viewBox: '0 0 16 24', color: color });
};
